import BusyImage from '@assets/images/frontend/not-found.png';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ModalStackPropsBase } from './ModalStackProvider';

interface SystemBusyModalProps extends ModalStackPropsBase<unknown, unknown> {
  onSubmit: () => void;
}

export function SystemBusyModal({ show, onSubmit }: SystemBusyModalProps) {
  const { t } = useTranslation();
  return <Modal show={show} backdrop="static" keyboard={false} dialogClassName="modal-dialog modal-md">
    <Modal.Body className="text-center">
      <img src={BusyImage} className="card-icon" alt="" />
      <div className="title">{t('Common.Label.SystemBusy')}</div>
      <p>{t('Common.Label.SystemBusySubmitDetail')}</p>
    </Modal.Body>
    <Modal.Footer className="text-center">
      <Button variant="primary" id="btn-system-busy-close" onClick={onSubmit}>
        {t('Common.Button.TryAgain')}
      </Button>
    </Modal.Footer>
  </Modal>;
}
